import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { GbDashboardSharedUiModule } from '@galabid/gb-dashboard/shared/ui'
import { TranslateModule } from '@ngx-translate/core'
import * as ProjectorTemplatesActions from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.actions'
import { ProjectorTemplatesFacade } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.facade'
import { GbPresenterTemplateConfigComponent } from 'libs/gb-dashboard/presenter/feature/src/lib/gb-presenter-template-config/gb-presenter-template-config.component'

@Component({
  selector: 'gb-add-projector-template-dialog',
  imports: [
    GbDashboardSharedUiModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    GbPresenterTemplateConfigComponent,
  ],
  templateUrl: './gb-add-projector-template-dialog.component.html',
  styleUrl: './gb-add-projector-template-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbAddProjectorTemplateDialogComponent {
  @ViewChild(GbPresenterTemplateConfigComponent)
  private gbPresenterTemplateConfigComponent?: GbPresenterTemplateConfigComponent

  constructor(private projectorTemplatesFacade: ProjectorTemplatesFacade) {}

  get template() {
    return this.gbPresenterTemplateConfigComponent?.form.value
  }

  confirm(): void {
    const { clientAccounts, ...rest } = this.template || {}

    const payload = {
      ...rest,
      schema_version: 2,
      client_accounts: this.template?.clientAccounts || [],
    }

    this.projectorTemplatesFacade.dispatch(
      ProjectorTemplatesActions.createProjectorTemplate({
        template: payload,
      }),
    )
  }
}
